import { defineComponent, ref, watch } from 'vue';
import './index.less';
import { useModal } from '/@/components/Modal';
import { propTypes } from '/@/utils/propTypes';
import JsonEditorModal from '../../do_back/config_platform/components/json_editor.vue';
import UploadModal from './modals/UploadModal.vue';
import { defHttp } from '/@/utils/http/axios';
import { Upload, message } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import { computed, Plugin } from '@vue/runtime-dom';

export const jsonParser = defineComponent({
  props: {
    title: propTypes.string.def(''),
    fileType: propTypes.string.def('excel'),
    value: propTypes.object.isRequired.def({}),
    templateUrl: propTypes.string.def(''),
  },
  emits: ['commit'],
  setup(props, { emit }) {
    const data = ref<any>();
    const isExcel = computed(() => props.fileType === 'excel');
    watch(
      () => props.value,
      (val) => {
        if (Array.isArray(val)) {
          data.value = [...val];
        } else {
          data.value = { ...val };
        }
      }
    );
    //获取解析json的url
    const getJsonUrl = window.ENV_CONFIG.nodeWebUrl + '/excel/jsonParser';
    const [registerJsonEditorModal, { openModal: openJsonEditorModal }] = useModal();
    const [registerUploadModal, { openModal: openUploadModal }] = useModal();

    // 向父组件传出standardJson
    const onOk = async (data) => {
      emit('commit', data);
    };

    //获取解析的json
    const getJsonData = async (val) => {
      data.value = await defHttp.post({ url: getJsonUrl, data: { url: val } });
      await onOk(data.value);
    };
    return {
      getJsonUrl,
      data,
      isExcel,
      getJsonData,
      registerJsonEditorModal,
      openJsonEditorModal,
      onOk,
      registerUploadModal,
      openUploadModal,
    };
  },
  render() {
    return (
      <div class="d-tag-content">
        <div class="title-content">
          <span class="title">{this.$props.title}</span>
          <a-button
            class="editable-add-btn"
            type="primary"
            preIcon="ant-design:plus-outlined"
            onClick={() => {
              this.openJsonEditorModal(true, { data: this.data });
            }}
          >
            编辑
          </a-button>

          {/* 区分解析excel还是json */}
          {this.isExcel ? (
            <a-button
              class="upload-btn"
              type="primary"
              preIcon="ant-design:upload-outlined"
              onClick={() => {
                this.openUploadModal(true, {});
              }}
            >
              上传
            </a-button>
          ) : (
            <Upload
              class="editable-add-btn"
              showUploadList={false}
              accept=".json"
              fileList={[]}
              beforeUpload={(file) => {
                const isJson = file.type === 'application/json';
                if (!isJson) {
                  message.error(`${file.name}不是json格式文件`);
                }

                return isJson || Upload.LIST_IGNORE;
              }}
              customRequest={async (e) => {
                // 假设 file 是您获取到的 File 对象
                const fileReader = new FileReader();

                fileReader.onload = (event) => {
                  if (event.target) {
                    const result = event.target.result;
                    if (typeof result === 'string') {
                      this.data = JSON.parse(result);
                      this.onOk(this.data);
                      message.success('导入成功');
                    } else {
                      message.error('导入失败');
                    }
                  }
                };

                fileReader.readAsText(e.file as File);
              }}
            >
              <a-button
                type="primary"
                // preIcon="ant-design:plus-outlined"
                onClick={() => { }}
              >
                <UploadOutlined></UploadOutlined>导入
              </a-button>
            </Upload>
          )}
        </div>

        <JsonEditorModal
          onRegister={this.registerJsonEditorModal}
          onCommit={(data) => this.onOk(data)}
        ></JsonEditorModal>

        {/* 上传excel文件  */}
        {this.isExcel && (
          <UploadModal
            templateUrl={this.$props.templateUrl}
            onRegister={this.registerUploadModal}
            onCommit={async (data) => {
              await this.getJsonData(data);
            }}

          ></UploadModal>
        )}
      </div>
    );
  },
});

export const DJsonParser: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DJsonParser', jsonParser);
  },
};
